<template>
    <div class="tab_content">
        <div class="tab">
            <div :class="['item', current == item.id ? 'active' : '' ]" v-for="item in category" :key="`category${item.id}`" @click="changeCategory(item.id)">
                {{ item.name }}
            </div>
        </div>
        <div class="">
            <div class="group">
                <div :class="['item', breed_ids.indexOf(item.breed_id) < 0 ? '': 'checked' ]" v-for="(item, index) in breedList" :label="item.breed_id" :key="`brand_${index}`" @click="check(item.breed_id)">
                    {{ item.breed }}
                </div>
                <el-checkbox class="check_all_item" v-model="is_all" @change="checkAll">全选</el-checkbox>
            </div>
        </div>
        <div class="flex_1 tableFlex clearfix">
            <!-- <vue-waterfall-easy ref='waterfall' id="pic" :imgsArr="list" :imgWidth="564"  @scrollReachBottom="getData" :gap="10">
                <div slot="waterfall-over"></div>
                <div class="img-info" slot-scope="{value, index}">
                </div>
            </vue-waterfall-easy> -->
            <div class="img-info" v-for="(value,index) in list" :key="index">
                <table border="1">
                    <thead>
                        <tr>
                            <th :class="`col col_${colIndex+1}`" v-for="(item, colIndex) in value.col" :key="`col${index}${colIndex}`" :colspan="colIndex == 0 ? 2 : 1">{{item}}</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, listIndex) in value.list" :key="`col${index}${listIndex}`">
                        <tr v-for="(data, itemIndex) in item.list" :key="`col${index}${listIndex}${itemIndex}`">
                            <td :rowspan="item.list.length" v-if="itemIndex == 0">{{item.grade}}</td>
                            <td v-for="(d, dataIndex) in data" :key="`col${index}${listIndex}${itemIndex}${dataIndex}`">
                                <span :class="{ blue : dataIndex > 0}" @click="showDetail(listIndex, itemIndex, dataIndex, value)">{{d}}</span>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
        <el-dialog v-dialog-drag title="明细详情" :visible.sync="dialogVisible" class="warsehouseDetailTable" width="400px">
            <el-table :data="detail" border stripe size="mini">
                <el-table-column prop="spec" label="规格"></el-table-column>
                <el-table-column prop="grade" label="等级"></el-table-column>
                <el-table-column prop="pieces" label="片数"></el-table-column>
                <el-table-column prop="sales_cube" label="方数"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .tab{
        display: flex; align-items: center; font-size:16px; color:rgba(51,51,51,1);
        .item{
            border-bottom: 3px solid transparent; padding:4px; cursor: pointer;
            &.active{ border-color: #B21111}
        }
        .item + .item{ margin-left: 75px}
    }
    .group{
        display: flex; flex-wrap: wrap;
        .item{ min-width:85px; height:36px; line-height: 36px; text-align: center; padding: 0 12px; border-radius:3px; border:1px solid rgba(102,102,102,1); cursor: pointer; margin: 6px; }
        .item.checked{
            border:1px solid rgba(178,17,17,1); position: relative; color: #B21111;
            &::after{ display: block; content: ""; width:21px; height:21px; position: absolute; right: 0; bottom: 0; background: url("/icon/checkeded.png") no-repeat; background-size: cover; }
        }
        .check_all_item{ height:36px; line-height: 36px; text-align: center; margin: 6px; }
    }
    .flex_1{ flex: 1; }
    .img-info{float: left;margin:10px;
        table{
            border-collapse: collapse; white-space: nowrap; font-size: 14px; text-align: center;
            td{ height:42px; }
            .col{ width:100px; height:42px; }
            .col_1{ width:168px; background:rgba(178,17,17,1); color: #fff; }
        }
    }
    .blue{ color: rgb(21, 91, 212); cursor: pointer; }
    .tableFlex{width:100%;height: 100%;overflow: auto;flex-flow: column wrap;}
</style>
<script>
    // import vueWaterfallEasy from 'vue-waterfall-easy'
    export default {
        components:{
            // vueWaterfallEasy,
        },
        data(){
            return{
                category : [
                    { id : 1, name: "北美材" },
                    { id : 2, name: "非洲材" },
                    { id : 3, name: "原木" },
                ],
                current : 1,

                is_all : true,

                list : [],
                breed_ids: [],
                breedList : [],
                dialogVisible : false,

                detail : [],
            }
        },

        methods:{
            changeCategory(id){
                this.current = id;
                this.breed_ids = [];
                this.breedList = [];
                this.list = [];
            },

            check(id){
                let index = this.breed_ids.indexOf(id);
                if(index < 0){
                    this.breed_ids.push(id);
                } else {
                    this.breed_ids.splice(index, 1);
                }
                this.is_all = this.breed_ids.length === this.breedList.length;
            },
            getBreedList(){
                this.$axios.post("/erp/report.breed.list",{
                    category : this.current
                }).then((response) => {
                    if(response.data.code == 0){
                        this.breedList = response.data.data
                        // this.breed_ids.push(this.breedList[0].breed_id);
                        // this.is_all = this.breed_ids.length === this.breedList.length;
                        this.checkAll(true)
                    }
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            async getList(){
                await this.getBreedList();
                // await this.getData();
            },
            getData(){
                this.postFuncLoading("/erp/report.inventory.breed",{
                    breed_ids : this.breed_ids,
                    category : this.current
                },response=>{
                    if(response.data.code == 0){
                        this.list = response.data.data;
                    }
                })
            },
            checkAll(value){
                // window.console.log(value)
                if(value){
                    this.breed_ids = this.breedList.map( (item) => {
                        return item.breed_id;
                    })
                } else {
                    this.breed_ids = [];
                }
                // window.console.log(this.breed_ids)
            },
            showDetail(row, subRow, col, data){
                // window.console.log(row, subRow, col);
                // window.console.log(data.list[row], data.list[row].grade, data.list[row].list[subRow][0], data.col[col], data.col[0]);
                this.$axios.post("/erp/report.inventory.breed.detail",{
                    category : this.current,
                    breed : data.col[0],
                    grade : data.list[row].grade,
                    warehouse : data.col[col],
                    sales_spec: data.list[row].list[subRow][0]
                }).then((response) => {
                    if(response.data.code == 0){
                        this.detail = response.data.data;
                        this.dialogVisible = true;
                    }
                })
            }
        },
        watch:{
            'breed_ids':function(){
				this.getData();
			},
            current(){
                this.is_all  = true;
                this.getBreedList();
            }
        }
    }
</script>
